import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { IdleSessionService } from './services/idle-session.service';
import { LoginService } from './services/login.service';
import { Router } from '@angular/router';
import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import {
  AuthenticationResult,
  InteractionStatus,
  PopupRequest,
  RedirectRequest,
} from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { StorageService } from './services/storage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserProfileService } from './services/user-profile.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SwUpdate } from '@angular/service-worker';
import { AnalyticsService } from './services/analytics.service';
import { OrderService } from './services/order.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  showInvalid: boolean = false;
  order_reviewer: any;
  otp_validation: any;

  constructor(
    private spinner: NgxSpinnerService,
    private idleSessionService: IdleSessionService,
    private loginServices: LoginService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private router: Router,
    private authService: MsalService,
    private storageService: StorageService,
    private modalService: NgbModal,
    private msalBroadcastService: MsalBroadcastService,
    private userService: UserProfileService,
    private httpClient: HttpClient,
    private swUpdate: SwUpdate,
    private orderService: OrderService,
    private analytics: AnalyticsService,
    private deviceService: DeviceDetectorService,
  ) {}
  title = 'doqfy_biz-portal';
  isIframe = false;
  private readonly _destroying$ = new Subject<void>();

  ngOnInit() {
    this.spinner.show();
    this.isIframe = window !== window.parent && !window.opener;
    this.analytics.logAppContext();
    // console.log('in appcomponent');
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event: Event) {
    this.loginServices.logoutBeacon();
  }
}